import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useParams } from "react-router-dom";
import Button from "../components/form/Button";
import Image from "../components/elements/Image";
import { classNames } from "../helpers/classNames";
import { useSelector } from "react-redux";
import AuthDropdown from "./AuthDropdown";

const FrontHeader = () => {
  const params = useParams();
  const location = useLocation();
  const { session } = useSelector((state) => state?.authProvider);
  const user = useSelector((state) => state?.profile?.data);

  const [menuOpen, setMenuOpen] = useState(false);
  const [isAppStatus, setAppStatus] = useState(false);
  const [language, setLanguage] = useState(1);
  const { siteSetting } = useSelector((state) => state.setting);
  const menudata = [
    { _id: 1, link: "/vpeters", name: "V'Peters" },
    { _id: 2, link: "/apply", name: "Apply" },
    { _id: 3, link: "/projects", name: "Projects" },
    { _id: 4, link: "/updates-and-blogs", name: "Updates & Blogs" },
    { _id: 5, link: "/contact", name: "Contact" },
  ];

  useEffect(() => {
    if (location?.hash === "#status") {
      setAppStatus(true);
    }
  }, [location?.hash]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header className="sticky top-0 w-full z-50">
        <div className="bg-sidebar flex items-center h-[3.5rem]">
          <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
            <div className="relative flex justify-between xls:grid grid-cols-3">
              <div className="relative hidden xls:flex justify-start"></div>
              <div className="flex items-center xls:justify-center w-full">
                <Button
                  buttonLabel={"Check Status"}
                  buttonLabelClasses={"!text-xl !font-medium"}
                  buttonClasses={
                    "!bg-transparent !text-primary hover:!bg-primary hover:!text-white"
                  }
                  buttonFunction={() => setAppStatus(true)}
                />
              </div>
              <div className="relative w-full flex flex-wrap items-center justify-end gap-3 sm:gap-6">
                {/* <div className="relative flex items-center gap-1">
                  <Select
                    xPlacement={"bottomRight"}
                    dropdownButtonClass={
                      "!rounded-none !bg-transparent !border-none !text-white"
                    }
                    dropdownClass={"!w-24"}
                    optionsClass={"!text-sm"}
                    dropdownData={[
                      { name: "English", value: 1 },
                      { name: "Spanish", value: 2 },
                      { name: "French", value: 3 },
                    ]}
                    selectedValue={language}
                    onChange={setLanguage}
                  />
                  <div className="text-white text-xl">
                    <i className="fa-light fa-globe"></i>
                  </div>
                </div> */}
                <div className="relative">
                  {session?.status !== "loading" &&
                    session?.status === "authorized" && (
                      <AuthDropdown user={user || {}} />
                    )}
                  {session?.status !== "loading" &&
                    session?.status === "unauthorized" && (
                      <Button
                        buttonLabel={"Sign In /Register"}
                        buttonIcon={"fa-light fa-circle-user text-xl"}
                        buttonIconPosition={"right"}
                        buttonLabelClasses={"!text-sm !font-medium"}
                        buttonClasses={"!bg-transparent !px-0"}
                        buttonHasLink={true}
                        buttonLink={"/authentication"}
                      />
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="fixed top-12 left-0 w-full py-4 z-[1]">
          <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
            <div className="flex items-center justify-between bg-white px-5 h-20 rounded-xl shadow-[0px_2px_10px_rgba(0,0,0,0.2)] gap-1 md:gap-4">
              <div className="h-11 md:h-14 overflow-hidden mr-auto xls:mr-0">
                {siteSetting?.logo?.url ? (
                  <Link to={"/"} className="flex w-full h-full">
                    <Image
                      src={siteSetting?.logo?.url}
                      alt=""
                      effect={"blur"}
                      classes={"object-contain object-left"}
                    />
                  </Link>
                ) : (
                  <div className="relative top-14 w-32 h-12 bg-gray-200 animate-pulse" />
                )}
              </div>
              <div className="relative z-[1] order-2 xls:order-1">
                <div className="relative xls:hidden">
                  <Button
                    buttonClasses={
                      "!h-10 md:!h-12 !rounded-lg !px-0 !aspect-square"
                    }
                    buttonHasLink={false}
                    buttonIcon={"fa-regular fa-fw fa-bars text-2xl"}
                    buttonIconPosition={"left"}
                    buttonFunction={() => setMenuOpen(true)}
                  />
                </div>
                <div
                  className={classNames(
                    "fixed top-0 left-0 w-full h-full bg-black/75 z-0 xls:hidden transition-all duration-200",
                    menuOpen ? "opacity-100 visible" : "opacity-0 invisible"
                  )}
                  onClick={() => setMenuOpen(false)}
                ></div>
                <div
                  className={classNames(
                    "fixed top-0 left-0 w-full h-full max-w-64 z-20 bg-slate-200 xls:bg-white shadow-[-4px_0_20px_rgba(0,0,0,0.15)] xls:relative xls:top-auto xls:left-auto xls:w-auto xls:h-auto xls:max-w-none xls:shadow-none transition-all duration-200",
                    menuOpen
                      ? "translate-x-0"
                      : "-translate-x-full xls:translate-x-0"
                  )}
                >
                  {menudata?.length > 0 && (
                    <nav className="relative flex px-8 py-8 xls:py-0 xls:px-0">
                      <div className="flex flex-col w-full xls:flex-row gap-4 xls:gap-8">
                        {menudata?.map((item, index) => (
                          <NavLink
                            to={item.link}
                            key={index}
                            className={({ isActive }) =>
                              classNames(
                                "relative flex items-center text-xl xls:text-base font-medium h-10 xls:h-20",
                                "after:hidden after:xls:block after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:w-12 after:h-1.5 after:bg-primary after:rounded-t-md after:transition-all after:duration-300 after:origin-center after:-translate-x-1/2 after:scale-x-0 ",
                                isActive
                                  ? "after:scale-x-100 text-primary xls:text-sidebar"
                                  : "after:hover:scale-x-100 text-black"
                              )
                            }
                          >
                            {item.name}
                          </NavLink>
                        ))}
                      </div>
                    </nav>
                  )}
                </div>
              </div>
              <div className="relative z-0 order-1 xls:order-2">
                <Button
                  buttonClasses={"!h-10 md:!h-12 !rounded-lg !px-3 md:!px-8"}
                  buttonHasLink={false}
                  buttonFunction={() => {
                    window.location.replace("/take-action");
                  }}
                  buttonLabel={"Take Action"}
                  buttonLabelClasses={"!text-xs md:!text-lg whitespace-nowrap"}
                />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default FrontHeader;
